import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-more-horizontal-outline",
  "use": "icon-more-horizontal-outline-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-more-horizontal-outline\"><g data-name=\"Layer 2\"><g data-name=\"more-horizotnal\"><rect width=\"24\" height=\"24\" opacity=\"0\" /><circle cx=\"12\" cy=\"12\" r=\"2\" /><circle cx=\"19\" cy=\"12\" r=\"2\" /><circle cx=\"5\" cy=\"12\" r=\"2\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol